export const messagingConstants = {

    SYNC_MESSAGES_CHANNEL_REQESUT: "SYNC_MESSAGES_CHANNEL_REQESUT",
    SYNC_MESSAGES_CHANNEL_SUCCESS: "SYNC_MESSAGES_CHANNEL_SUCCESS",
    SYNC_MESSAGES_CHANNEL_FAILEUR: "SYNC_MESSAGES_CHANNEL_FAILEUR",

    SET_MESSAGES_CHANNEL: "SET_MESSAGES_CHANNEL"
};